import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  center?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  center = false,
}: SectionHeadingProps) {
  return (
    <div
      className={
        center
          ? "flex flex-col items-center text-center gap-3"
          : "flex flex-col gap-3 md:flex-row md:items-end md:justify-between"
      }
    >
      <div className={center ? "flex flex-col items-center gap-2" : "flex flex-col gap-2"}>
        {eyebrow ? (
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-700 uppercase">
            <span className="w-6 h-px bg-primary-400" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
          {title}
        </h2>
        {desc ? (
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">{desc}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}